import { render, staticRenderFns } from "./trpllore.vue?vue&type=template&id=1133603a&scoped=true"
import script from "./trpllore.vue?vue&type=script&lang=js"
export * from "./trpllore.vue?vue&type=script&lang=js"
import style0 from "./trpllore.vue?vue&type=style&index=0&id=1133603a&prod&lang=scss&scoped=true"
import style1 from "./trpllore.vue?vue&type=style&index=1&id=1133603a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1133603a",
  null
  
)

export default component.exports